import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { faqs } from '../../data/programa';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="border-b border-line bg-carbon py-[60px] lg:py-[100px]" data-id="element-103" data-mp="1235324nxj2vp">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-104" data-mp="1pspqazr48mas">
        <SectionHeading eyebrow="Preguntas frecuentes" title={<>
              Lo que más <span className="text-gold" data-id="element-106" data-mp="1g2e8c9alkckw">nos preguntan</span>
            </>} data-id="element-105" data-mp="1urtz3pa4oi0l" />

        <div className="mx-auto mt-12 max-w-3xl" data-id="element-107" data-mp="1g0bn02ke37mi">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <Reveal key={faq.question} delay={index * 0.04} data-id="element-108" data-mp="28qju8zde07mb" data-mpi={index}>
                <div className="border-b border-line" data-id="element-109" data-mp="28p8s13zlb7xb">
                  <h3 data-id="element-110" data-mp="2ditqsy90c5xk">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-6 text-left" data-id="element-111" data-mp="2dj37twc2r2r4">
                      <span className="text-[17px] font-semibold leading-snug text-ice sm:text-[19px]" data-id="element-112" data-mp="2yg1u2wknfe2r">
                        {faq.question}
                      </span>
                      <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-113" data-mp="2to0o1se2qjl6" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-114" data-mp="3hew9m7rxsijz">
                    {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-115" data-mp="3hee7iuilfa45">
                        <p className="max-w-2xl pb-7 text-[16px] leading-[1.7] text-cool" data-id="element-116" data-mp="2bqrapxrmyskp">
                          {faq.answer}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}